import { Card } from '@features/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ResetFormData, schemaResets } from '@src/types/productsAddons.ts';
import { getProductDetail, saveProductReset } from '@src/services/products.ts';
import { buildProductReset, mapperProductResets } from '@lib/products.ts';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEffect, useRef } from 'react';
import { ResetForm } from '@features/admin/productsAddons/ResetForm.tsx';
import { useProductOptions } from '@hooks/useProductOptions.tsx';

export const ResetEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);
  const { productOptions } = useProductOptions();

  const handleSubmitForm = async (data: ResetFormData) => {
    try {
      const makeData = buildProductReset(data);

      await saveProductReset(Number(id), makeData);
    } catch {
      toast.error('Something went wrong. Please try again later.');
    }
  };

  const method = useForm<ResetFormData>({
    resolver: yupResolver(schemaResets),
  });

  useEffect(() => {
    if (!id) return;
    getProductDetail(Number(id))
      .then((res) => {
        const productFormData = mapperProductResets(res.data);

        method.reset(productFormData);
      })
      .catch(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        alert('Product not found!');
        navigate('/admin/products-addons');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div>
      <div className={'flex'}>
        <div className={'flex flex-col gap-y-2.5 mb-4'}>
          <p className={'text-[23px] font-medium text-blue'}>Reset Edit</p>
          <div className={'h-[2px] w-full bg-blue'} />
        </div>
      </div>
      <Card>
        <FormProvider {...method}>
          <form
            autoComplete="off"
            onSubmit={method.handleSubmit(handleSubmitForm)}
          >
            <ResetForm {...method} productOptions={productOptions} />
          </form>
        </FormProvider>
      </Card>
    </div>
  );
};
